module.exports = __webpack_public_path__ + "static/media/Payroll_icon.e4f4ae5a.png";